// Version : 0.0.2
// Author : SHIYAM
// LastEdit : SHIYAM
// Last ADD : Added version and command lines
// MODFIED DATE : 05-09-2025

// /* eslint-disable eslint-comments/disable-enable-pair */

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

// CREATE BUSINESS DETAILS
export const createBusinessDetails = (businessData: any) => {
	const data = {
		AddBusinessTokenDetails: businessData,
	};
	const url = `${API_URL}addBusinessDetails`;
	return makeApiCall(url, data);
};

// UPDATE BUSINESS DETAILS
export const updateBusinessDetails = (updateData: any) => {
	const data = {
		UpdateBusinessDetailsToken: updateData,
	};
	const url = `${API_URL}updateBusinessDetails`;
	return makeApiCall(url, data);
};

// FETCH BUSINESS DETAILS
export const fetchBusinessDetails = (fetchData: any) => {
	const data = {
		GetBusinessDetailsToken: fetchData,
	};
	const url = `${API_URL}getBusinessDetails`;
	return makeApiCall(url, data);
};

// DELETE BUSINESS DETAILS
export const deleteBusinessDetails = (deleteData: any) => {
	const data = {
		DeleteBusinessDetailsToken: deleteData,
	};
	const url = `${API_URL}deleteBusinessDetails`;
	return makeApiCall(url, data);
};

// BUSINESS LIST GET
export const businessListGet = (listData: any) => {
	const data = {
		GetBusinessListToken: listData,
	};
	const url = `${API_URL}getBusinessDetailsList`;
	return makeApiCall(url, data);
};

// CHECK BUSINESS DETAILS EXIST
export const checkExistData = (listData: any) => {
	const data = {
		ExistBusinessDataToken: listData,
	};
	const url = `${API_URL}isExistCheckBusiness`;
	return makeApiCall(url, data);
};

// BUSINESS APPROVE CHECK
export const checkBusinessApprove = (approveData: any) => {
	const data = {
		BusinessApproveToken: approveData,
	};
	const url = `${API_URL}updateIsBusinessApprove`;
	return makeApiCall(url, data);
};
